export default __webpack_public_path__ + "static/media/007.b27bb883.png";